// extracted by mini-css-extract-plugin
export default {"container":"style_container__DGV-8","content":"style_content__YmG1c"};